<template>
  <Transition :name="`slide-fade-${direction}`">
    <slot />
  </Transition>
</template>

<script lang="ts" setup>
import { watch } from 'vue'
import { TRANSITION_SIDE_DIRECTIONS } from '@/modules/core/constants/common'
const props = defineProps({
  direction: {
    type: String,
    default: TRANSITION_SIDE_DIRECTIONS.RIGHT
  }
})

watch(
  () => props.direction,
  (value) => {
    if (!validate(value)) {
      throw new Error(`Invalid direction: ${value}`)
    }
  }
)

function validate(value: string) {
  return Object.values(TRANSITION_SIDE_DIRECTIONS).includes(value)
}
</script>

<style lang="scss">
$delay: 0.5s;

.slide-fade-left,
.slide-fade-right {
  &-enter-active {
    transition: all $delay ease-out $delay;
  }

  &-leave-active {
    transition: all $delay ease-out;
  }

  &-leave-to {
    position: absolute;
    opacity: 0;
  }

  &-enter-from {
    opacity: 0;
  }
}

.slide-fade-left {
  &-enter-from {
    transform: translateX(-100px);
  }

  &-leave-to {
    transform: translateX(100px);
  }
}

.slide-fade-right {
  &-enter-from {
    transform: translateX(100px);
  }

  &-leave-to {
    transform: translateX(-100px);
  }
}
</style>
